module.exports = "<em>Power resource needed:</em>\n{{ powerNeeded$ | async | number }}\n"


//////////////////
// WEBPACK FOOTER
// /home/runner/work/power-planner/power-planner/src/app/page-main.module/power-resource-needed.component/power-resource-needed.component.html
// module id = ../../../../../src/app/page-main.module/power-resource-needed.component/power-resource-needed.component.html
// module chunks = main